import { render, staticRenderFns } from "./studyGoal.vue?vue&type=template&id=e83d806e&scoped=true&"
import script from "./studyGoal.vue?vue&type=script&lang=js&"
export * from "./studyGoal.vue?vue&type=script&lang=js&"
import style0 from "./studyGoal.vue?vue&type=style&index=0&id=e83d806e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83d806e",
  null
  
)

export default component.exports